import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {takeUntil} from 'rxjs/operators';
import {UsersService} from '../../users/users.service';
import {Subject} from 'rxjs';
import {validEmail} from 'src/app/shared/validators/email.validator';
import {NotificationService} from 'src/app/shared/notification.service';
import {TranslateService} from "@ngx-translate/core";
import {marker} from "@biesbjerg/ngx-translate-extract-marker";

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
    standalone: false
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
  rpForm: FormGroup;
  private destroyed$: Subject<void> = new Subject<void>();
  submitted = false;
  loading = false;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    public notificationService: NotificationService,
    private usersService: UsersService,
    private translateService: TranslateService
  ) {
  }


  ngOnInit() {
    this.rpForm = this.formBuilder.group({
      username: ['', Validators.required],
      email: ['', [Validators.required, validEmail]],
    });
  }

  send() {
    this.submitted = true;
    this.loading = true;

    this.usersService.resetPasswordSelf(this.rpForm.get('username').value, this.rpForm.get('email').value)
      .pipe(
        takeUntil(this.destroyed$),
      )
      .subscribe(
        (response) => {
          const successMessage = 'Success! If the username/email combination you entered is valid, you will receive an email with a temporary password.';
          this.notificationService.success(this.translateService.stream(marker(successMessage)));
        },
        error => {
          this.loading = false;
        },
        () =>  { this.loading = false; },
      );
  }

  cancel() {
    this.router.navigate(['/login']);
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}

